import { Order, NextPaymentResponse } from '../models/APIModels';

const CACHE_KEY = 'dashboard_orders_cache';
const CACHE_EXPIRY_MS = 5 * 60 * 1000; // 5 minutes

export interface CachedDashboardData {
  orders: Order[];
  nextPayments: { [orderId: number]: NextPaymentResponse };
  totalBoxDays?: number;
  membershipTier?: string;
  timestamp: number;
}

export function loadDashboardCache(): CachedDashboardData | null {
  try {
    const cached = localStorage.getItem(CACHE_KEY);
    if (!cached) return null;
    
    const data: CachedDashboardData = JSON.parse(cached);
    const now = Date.now();
    
    if (now - data.timestamp > CACHE_EXPIRY_MS) {
      localStorage.removeItem(CACHE_KEY);
      return null;
    }
    
    return data;
  } catch (error) {
    localStorage.removeItem(CACHE_KEY);
    return null;
  }
}

export function saveDashboardCache(
  orders: Order[],
  nextPayments: Map<number, NextPaymentResponse>,
  totalBoxDays?: number,
  membershipTier?: string
): void {
  try {
    const paymentsObject: { [orderId: number]: NextPaymentResponse } = {};
    nextPayments.forEach((value, key) => {
      paymentsObject[key] = value;
    });

    const data: CachedDashboardData = {
      orders,
      nextPayments: paymentsObject,
      totalBoxDays,
      membershipTier,
      timestamp: Date.now(),
    };

    localStorage.setItem(CACHE_KEY, JSON.stringify(data));
  } catch (error) {
    // Silently fail if localStorage is not available
  }
}

export function clearDashboardCache(): void {
  try {
    localStorage.removeItem(CACHE_KEY);
  } catch (error) {
    // Silently fail if localStorage is not available
  }
}

export function convertPaymentsMapToObject(
  paymentsMap: Map<number, NextPaymentResponse>
): { [orderId: number]: NextPaymentResponse } {
  const paymentsObject: { [orderId: number]: NextPaymentResponse } = {};
  paymentsMap.forEach((value, key) => {
    paymentsObject[key] = value;
  });
  return paymentsObject;
}

export function convertPaymentsObjectToMap(
  paymentsObject: { [orderId: number]: NextPaymentResponse }
): Map<number, NextPaymentResponse> {
  const paymentsMap = new Map<number, NextPaymentResponse>();
  Object.entries(paymentsObject).forEach(([key, value]) => {
    paymentsMap.set(Number(key), value);
  });
  return paymentsMap;
}

